'use client';

import { usePathname } from 'next/navigation';

import OpenMobChatsIcon from '@/components/icons/OpenMobChatsIcon';
import useMobileChatsDrawer from '@/hooks/useMobileChatsDrawer';

function MobileChatButton() {
  const { isOpenMobileChatsDrawer, openMobileChatsDrawer, closeMobileChatsDrawer } =
    useMobileChatsDrawer();

  const pathname = usePathname();
  if (!pathname.startsWith('/chat')) {
    return null;
  }

  return (
    <button
      onClick={isOpenMobileChatsDrawer ? closeMobileChatsDrawer : openMobileChatsDrawer}
      className="mr-3 flex h-10 w-10 min-w-10 items-center justify-center rounded-full border-1 border-solid border-white lg:mr-6 lg:hidden"
    >
      <OpenMobChatsIcon />
    </button>
  );
}
export default MobileChatButton;
